// External Dependencies
import styled from '@emotion/styled';

// Component Definition
const NavItemList = styled.ul({
  display: 'flex',
});

export default NavItemList;
